export const LineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  borderColor: '#0092ef',
  borderWidth: 2,
  tension: 0.2,
  interaction: {
    intersect: false,
    mode: 'index',
  },
  scales: {
    y: {
      ticks: {
        // Include a dollar sign in the ticks
        callback: (value) => '$' + value,
        maxTicksLimit: 4,
      },
    },
    x: {
      ticks: {
        maxTicksLimit: 4,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: 'white',
      titleColor: 'black',
      displayColors: false,
      boxPadding: 5,
      titleSpacing: 4,
      bodyColor: 'black',
      borderColor: 'rgba(0,0,0,.4)',
      borderWidth: 1,
      cornerRadius: 3,
      callbacks: {
        label: function(context) {
          let label = ''
          if (context.parsed.y !== null) {
            label += new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(context.parsed.y)
          }
          return label
        },
      },
    },
  },
}

export const PieChartOptions = {
  responsive: true,
  hoverOffset: 4,
  // radius: 80,
  // height: 120,

  plugins: {
    tooltip: {
      backgroundColor: 'white',
      titleColor: 'black',
      displayColors: false,
      boxPadding: 5,
      titleSpacing: 4,
      bodyColor: 'black',
      borderColor: 'rgba(0,0,0,.4)',
      borderWidth: 1,
      cornerRadius: 3,
      // callbacks: { label: (label) => label, },
    },
    legend: {
      position: 'right',
      labels: {
        usePointStyle: true,
      },
    },
  },
}
export const SuperAdminBarChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  borderColor: '#0092ef',
  backgroundColor: '#0092ef',
  borderWidth: 0,
  interaction: {
    intersect: false,
    mode: 'index',
  },
  scales: {
    y: {
      ticks: {
        // Include a dollar sign in the ticks
        callback: (value) => '$' + value,
        maxTicksLimit: 4,
      },
      // offset: true, // allow bars to extend beyond edges
      grid: {
        drawBorder: false,
      },
    },
    x: {
      ticks: {
        maxTicksLimit: 20,
        maxRotation: 70,
      },
      grid: {
        display: false,
        drawOnChartArea: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: 'white',
      titleColor: 'black',
      displayColors: false,
      boxPadding: 5,
      titleSpacing: 4,
      bodyColor: 'black',
      borderColor: 'rgba(0,0,0,.4)',
      borderWidth: 1,
      cornerRadius: 3,
      callbacks: {
        label: function(context) {
          let label = ''
          if (context.parsed.y !== null) {
            label += new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(context.parsed.y)
          }
          return label
        },
      },
    },
  },
}

export const BarChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  borderColor: '#0092ef',

  interaction: {
    intersect: false,
    mode: 'index',
  },
  scales: {
    y: {
      stacked: true,

      ticks: {
        maxTicksLimit: 4,
      },
    },
    x: {
      stacked: true,
      ticks: {
        maxTicksLimit: 4,
      },
    },
  },
  plugins: {
    tooltip: {
      backgroundColor: 'white',
      titleColor: 'black',
      displayColors: false,
      boxPadding: 5,
      titleSpacing: 4,
      bodyColor: 'black',
      borderColor: 'rgba(0,0,0,.4)',
      borderWidth: 1,
      cornerRadius: 3,
    },
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
      },
    },
  },
}

export const CHART_COLORS = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(75, 192, 192)',
  blue: 'rgb(54, 162, 235)',
  purple: 'rgb(153, 102, 255)',
  grey: 'rgb(201, 203, 207)',
}

export const NAMED_COLORS = [
  CHART_COLORS.grey,
  CHART_COLORS.blue,
  CHART_COLORS.green,
  CHART_COLORS.yellow,
  CHART_COLORS.orange,
  CHART_COLORS.red,
  CHART_COLORS.purple,
]
